import * as React from "react";
import * as ReactDOM from "react-dom";
import { toDataSourceRequestString, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { useGlobalState } from '../../App.js';
import { GridColumn, GridToolbar, Grid } from '@progress/kendo-react-grid';
import { NewForm } from './NewForm'

const UseGlobalStateWrapper = ({ render }) => {
    const [loginInfo, updateLoginInfo] = useGlobalState();
    return render(loginInfo, updateLoginInfo);
}

export function withState(WrappedGrid) {
    
    return class StatefullGrid extends React.Component {
        
        tokenVal = "";
        userId = "";

        constructor(props) {
            super(props); 
            this.state = {
                dataState: { skip: 0, take: 20 },
                openNewForm: false,                 
            };
        }

       render() {
           return (
               <UseGlobalStateWrapper render={(loginInfo, updateLoginInfo) => {
                   this.tokenVal = `Bearer ${loginInfo.token}`;
                   this.userId = `${loginInfo.userId}`;
                   console.log('TOKEN VAL:  ' + this.tokenVal);
                   return (
                       <WrappedGrid
                           filterable={true}
                           sortable={true}
                           pageable={{ pageSizes: true }}
                           {...this.props}
                           {...this.state.dataState}
                           total={this.state.total}
                           data={this.state.data}
                           skip={this.state.dataState.skip}
                           pageSize={this.state.dataState.take}
                           filter={this.state.dataState.filter}
                           sort={this.state.dataState.sort}
                           onDataStateChange={this.handleDataStateChange}
                           onItemChange={this.itemChange}
                       >
                           <GridToolbar>
                               <button
                                   title="Add new"
                                   className="k-button k-primary"
                                   onClick={this.addNew}
                               >Add new
                               </button>
                               {
                                   this.state.openNewForm && (
                                       <NewForm
                                           cancelNew={this.handleCancelNew}
                                           onSubmit={this.handleSubmitNew}
                                           item={this.state.newItem}
                                       />
                                   )
                               } 
                           </GridToolbar>

                           {this.props.children}

                       </WrappedGrid>
                       
                   );
               }} />
                );
                    
        }
        

        componentDidMount() {
            this.fetchData(this.state.dataState);
        }

        addNew = () => {            
            this.setState({
                openNewForm: true,
                newItem: {
                    "id": "00000000-0000-0000-0000-000000000000", 
                    "userName": "",
                    "password": "",
                    "emailAddress": "",
                    "allowUserManage": false,
                    "allowRecordingManage": false, 
                    "allowFileManage": false, 
                    "allowRoutingManage": false, 
                    "allowExtensionRights1": false
                }
            });
        };


        handleSubmitNew = (event) => { 
            this.addItem(event);
            this.setState({
                openNewForm: false,
            });
        }

        handleCancelNew = () => {
            this.setState({
                openNewForm: false,
            });
        };

        addItem = (item) => { 
            const base_url = 'api/users';
            const init = {
                method: 'POST', accept: 'application/json',
                headers: {
                    'accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': this.tokenVal
                },
                body: JSON.stringify(item)
            };
            fetch(`${base_url}?${toDataSourceRequestString(this.state.dataState)}`, init)
                .then(response => response.json())
                .then(json => this.setState({ data: json.data }))
        }

  

        cancelEdit = (item) => {
            this.itemInEdit = {};
            let data = this.state.data;
            let mappedData = data.map(record => {
                if (record.Id === this.itemInEdit.Id) {
                    record = this.itemInEdit;
                    record.itemInEdit = false
                } else {
                    record.itemInEdit = false;
                }
                return record
            });
            let filteredData = mappedData.filter(obj => Object.keys(obj).includes("Id"));
            this.setState({
                data: filteredData
            })
        };

        deleteItem = (item) => {
            const base_url = 'api/users';
            const init = {
                method: 'DELETE', accept: 'application/json',
                headers: {
                    'accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': this.tokenVal
                },
                body: JSON.stringify(item)
            };
            fetch(`${base_url}?${toDataSourceRequestString(this.state.dataState)}`, init)
                .then(response => response.json())
                .then(json => this.setState({ data: json.data }))
        }

        updateItem = (item) => {
           // const queryStr = this.serialize(item); // Serialize the state
            const base_url = 'api/users'; 
            const init = {
                method: 'PUT', accept: 'application/json',
                headers: {
                    'accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': this.tokenVal
                },
                body: JSON.stringify(item)
            };
            fetch(`${base_url}?${toDataSourceRequestString(this.state.dataState)}`, init)
                .then(response => response.json())
                .then(json => this.setState({ data: json.data }))
        }

        itemChange = (event) => {
            switch (event.value) {
                case "edit":
                    this.enterEdit(event.dataItem)
                    break;
                case "delete":
                    this.deleteItem(event.dataItem)
                    break;
                case "update":
                    if (event.dataItem.id) {
                        this.updateItem(event.dataItem)
                    } else {
                        this.addItem(event.dataItem)
                    }
                    break;
                case "cancel":
                    this.cancelEdit(event.dataItem)
                    break;
                default:
                    const data = this.state.result.slice();
                    const index = data.findIndex(d => d.id === event.dataItem.id);
                    data[index] = { ...data[index], [event.field]: event.value };
                    this.setState({
                        data: data
                    });
            }

        };

        handleDataStateChange = (changeEvent) => {
            console.log("handleDataStateChange: " + JSON.stringify(changeEvent.dataState));
            this.setState({ dataState: changeEvent.dataState });
            this.fetchData(changeEvent.dataState);
        }

        
        serialize = (obj) => {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        }

        fetchData(dataState) {
            console.log("FETCH DATA: TOKEN: " + this.tokenVal);
             
           // console.log("PROPS: " + JSON.stringify(this.props));
            const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state.
            const hasGroups = dataState.group && dataState.group.length;
            // const token = `Bearer  ${loginInfo.token}`;
            const base_url = 'api/users';
            const init = {
                method: 'GET', accept: 'application/json',
                headers: {
                    'accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': this.tokenVal
                }
            };

            fetch(`${base_url}?${queryStr}`, init)
                .then(response => response.json())
                .then(({ data, total }) => {
                    this.setState({
                        data: hasGroups ? translateDataSourceResultGroups(data) : data,
                        total,
                        dataState
                    });

                });
        }
    }
}